import React from 'react'
import { Stack, ListItemAvatar } from '@mui/material'
import { SPACING } from '../../typography'
import { ImageBlock } from '../../image-block'
import { DraftStack } from './stacks'

export function DraftItem (props) {
  const { wrestler = {}, children = null } = props

  return (
    <>
      {wrestler?.image && (
        <ListItemAvatar>
          <ImageBlock
            image={wrestler.image}
            backgroundColor={wrestler?.backgroundColor}
          />
        </ListItemAvatar>
      )}
      <Stack spacing={SPACING} sx={{ minWidth: 100 }}>
        <DraftStack {...props} />
      </Stack>
      {children}
    </>
  )
}
